module.exports = __webpack_public_path__ + "static/lk-d5cf9401eb1cf775f0923c6872eff30b.svg";